var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLastmessage = function SvgLastmessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 11.291c0 4.539-4.048 8.182-9 8.182a9.896 9.896 0 0 1-1.87-.179M6.599 17.826C4.42 16.336 3 13.974 3 11.291M6.6 17.826c-.002.854 0 2.006 0 3.215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11.29c0-4.538 4.048-8.18 9-8.18s9 3.643 9 8.182M10.13 19.29 6.6 21.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.177 11.323a.25.25 0 1 1-.354.354.25.25 0 0 1 .354-.354M16.177 11.323a.25.25 0 1 1-.354.354.25.25 0 0 1 .354-.354M8.177 11.323a.25.25 0 1 1-.354.354.25.25 0 0 1 .354-.354"
  }))));
};
export { SvgLastmessage as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYmY5N2IyMjg5OWU2MzEwOTcyNDdlMzM2Mjg4MGRhY2Muc3ZnIjs=";